import { mapGetters, mapMutations, mapState } from 'vuex'
import { mapConfig } from '@/composables/useConfig'

/**
 * Shared behavior for vehicle-route pages (VehiclePanel, PlafondPage,
 * RoutePage, AnalyzePage):
 *
 *   - exposes `truck` (= focus_truck) and `storeTrucks`
 *   - guards against an invalid `:id` param: if bootstrap has populated
 *     trucks and the route id doesn't match any, push back to index
 *   - provides `unfocusAndGoToIndex()` for pages that close to the main view
 */
export default {
    computed: {
        ...mapConfig(['vehicleListModeView']),
        ...mapState({
            storeTrucks: (state) => state.geoFleet.trucks
        }),
        ...mapGetters({
            focus_truck: 'getFocusTruck'
        }),
        truck() {
            return this.focus_truck
        }
    },
    beforeMount() {
        if (this.storeTrucks.length > 0 && !this.truck) {
            this.$router.push({ name: 'geofleet.index' })
        }
    },
    methods: {
        ...mapMutations({
            setFocusTruck: 'setFocusTruck',
            expandPanel: 'expandPanel'
        }),
        unfocusAndGoToIndex() {
            if (this.truck) {
                this.setFocusTruck({ truck: this.truck, on_focus: false })
            }
            this.expandPanel({ panel: 'main' })
            this.$router.push({ name: 'geofleet.index' })
        },
        // Close back to the vehicle details page, keeping the truck focused
        // (used by the plan/analyze pages so closing returns to the vehicle
        // rather than dropping focus and going to the index map).
        goToTruckDetails() {
            if (!this.truck) {
                this.$router.push({ name: 'geofleet.index' })
                return
            }
            this.$router.push({
                name: 'geofleet.vehicle_details',
                params: { id: this.truck.plate }
            })
        }
    }
}
